export type STATUS_TYPE = 'idle' | 'pending' | 'succeeded' | 'failed';

export type IParams = {
  id: string;
};

export enum PurchaseType {
  oneTime = 'oneTime',
  subscription = 'subscription',
}

export enum CarType {
  new = 'New',
  used = 'Used',
}

export enum CarAvailability {
  available = 'available',
  unAvailable = 'unAvailable',
  soldOut = 'soldOut',
}

export enum ScanType {
  car = 'car',
  carModel = 'carModel',
}